import { Plug } from 'lucide-react';
import { lazy } from 'react';

import { channelsTranslations as enChannels } from '@/lang/en/channels';
import { googleCalendarTranslations as enGoogleCalendar } from '@/lang/en/google-calendar';
import { whatsAppTranslations as enWhatsapp } from '@/lang/en/whatsapp';
import { channelsTranslations as esChannels } from '@/lang/es/channels';
import { googleCalendarTranslations as esGoogleCalendar } from '@/lang/es/google-calendar';
import { whatsAppTranslations as esWhatsapp } from '@/lang/es/whatsapp';
import { channelsTranslations as ptChannels } from '@/lang/pt/channels';
import { googleCalendarTranslations as ptGoogleCalendar } from '@/lang/pt/google-calendar';
import { whatsAppTranslations as ptWhatsapp } from '@/lang/pt/whatsapp';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { mergeBundles, namespaceBundle } from '@/platform/i18n/types';

import { channelMappingSlice } from './channels/domain/state/channelMappingSlice';
import { googleCalendarIntegrationSlice } from './google-calendar/domain/state/googleCalendarIntegrationSlice';
import { whatsappIntegrationSlice } from './whatsapp/domain/state/whatsappIntegrationSlice';

// Section and page components stay lazy so settings code ships with the
// settings chunk, not with the entry bundle.
const IntegrationsPage = lazy(() =>
  import('./presentation/pages/IntegrationsPage').then((m) => ({
    default: m.IntegrationsPage,
  })),
);

const MetaCapiPage = lazy(() =>
  import('./meta-capi/presentation/MetaCapiPage').then((m) => ({
    default: m.MetaCapiPage,
  })),
);

/** Channel integrations: WhatsApp, channel ↔ agent bindings, Google Calendar, Meta CAPI. */
export const integrationsModule: FeatureModule = {
  id: 'integrations',
  settingsSections: [
    {
      id: 'integrations',
      group: 'integrations',
      order: 10,
      label: label('settings', 'nav_integrations'),
      icon: Plug,
      Component: IntegrationsPage,
      wrapInSection: true,
    },
  ],
  settingsRoutes: [
    {
      path: 'integrations/meta-capi',
      to: '/app/settings/integrations/meta-capi',
      Component: MetaCapiPage,
    },
  ],
  slices: [channelMappingSlice, whatsappIntegrationSlice, googleCalendarIntegrationSlice],
  i18n: mergeBundles(
    namespaceBundle('channels', { es: esChannels, en: enChannels, pt: ptChannels }),
    namespaceBundle('googleCalendar', {
      es: esGoogleCalendar,
      en: enGoogleCalendar,
      pt: ptGoogleCalendar,
    }),
    namespaceBundle('whatsapp', { es: esWhatsapp, en: enWhatsapp, pt: ptWhatsapp }),
  ),
};
